import { AController } from "@eagerlogic/react-mvc";
import { ApiException } from "rpc/rpc";
import { AuthRpc } from "rpc/auth/AuthRpc";
import { Navigation } from "utils/Navigation";
import { AcceptInvitationModel } from "../model/AcceptInvitationModel";

export class AcceptInvitationController extends AController<AcceptInvitationModel> {

    protected createInitialModel(): AcceptInvitationModel {
        var model = new AcceptInvitationModel();
        model.isInit = true;

        var token = this.getToken();
        AuthRpc.invitationInfo(token).then((res) => {
            this.model.isInit = false;
            this.model.valid = res.valid;
            if (!res.valid) {
                this.model.globalError = res.error;
            } else {
                this.model.company = res.company;
                this.model.email = res.email;
                this.model.name = res.name == null ? "" : res.name;
            }
            this.render(this.model);
        }).catch((ex: ApiException) => {
            this.model.isInit = false;
            this.model.valid = false;
            this.model.globalError = ex.message != null ? ex.message : "Invalid invitation token!";
            this.render(this.model);
        });

        return model;
    }

    public onAcceptClicked(name: string, password: string) {
        this.model.name = name;
        this.model.password = password;
        this.model.nameError = null;
        this.model.passwordError = null;
        this.model.globalError = null;
        this.render(this.model);

        AuthRpc.acceptInvitation({
            token: this.getToken(),
            name: name,
            password: password
        }).then(() => {
            window.location.href = "/index.rsc";
        }).catch((ex: ApiException) => {
            this.model.nameError = this.fieldError(ex, "name");
            this.model.passwordError = this.fieldError(ex, "password");
            var emailError = this.fieldError(ex, "email");
            if (emailError != null) {
                this.model.globalError = emailError;
            } else if ((ex.fieldErrors == null || Object.keys(ex.fieldErrors).length < 1) && ex.message != null) {
                this.model.globalError = ex.message;
            }
            this.render(this.model);
        });
    }

    private getToken(): string {
        var token = Navigation.currentState.params["token"];
        return token == null ? "" : token;
    }

    private fieldError(ex: ApiException, field: string): string {
        if (ex != null && ex.fieldErrors != null && ex.fieldErrors[field] != null) {
            return ex.fieldErrors[field];
        }
        return null;
    }

}
